import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { isNumber } from 'webapp/utils/number';

import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type VisualizationTable from 'webapp/models-custom/visualization/table';

interface Args {
	blockM: Block;
}

export default class BlockSettingsRecordLimitComponent extends Component<Args> {
	@tracked recordLimitString = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.updateRecordLimitStringFromModel();
	}

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization as VisualizationTable;
	}

	get maxRecordLimit() {
		return this.visualization.recordLimit;
	}

	@action
	updateRecordLimitStringFromModel(): void {
		this.recordLimitString = String(this.block.recordLimit);
	}

	@action
	changeRecordLimit(): void {
		let recordLimit = this.maxRecordLimit;
		if (isNumber(this.recordLimitString)) {
			recordLimit = Math.min(this.maxRecordLimit, Math.max(+this.recordLimitString, 1));
		}
		this.recordLimitString = String(recordLimit);

		this.block.recordLimit = recordLimit;
		const blockSetup = this.blockSetup;
		if (blockSetup?.isAutosaveOn) {
			blockSetup.saveBlock();
		}
	}
	<template>
		<div class="row" {{didUpdate this.updateRecordLimitStringFromModel @blockM.recordLimit}}>
			<label class="right--half">Max # of rows</label>
			<div class="right--half">
				<FormInputComponent
					maxlength="3"
					@loseFocusOnEnter={{true}}
					@value={{this.recordLimitString}}
					@focusOut={{this.changeRecordLimit}}
					@hideFloatLabel={{true}}
					@theme="dark"
				/>
			</div>
		</div>
	</template>
}
